import React from 'react';

import { Currency, CurrencyProps } from '@block-explorer/ui';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';

export const FiatCurrency = (props: Omit<CurrencyProps, 'currencyLabel'>) => {
  const { selectedCurrency: currency } = useSelector(
    (state: RootState) => state.currencies
  );

  return <Currency {...props} currencyLabel={currency.code} />;
};

export default FiatCurrency;
